export default "/assets/images/problem-solved-06.b03709347ae694a4.png";